<fui-modal [state]="state" [maxWidth]="'700px'" [maxHeight]="'450px'">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="close()" [title]="title">
        </fui-modal-window-toolbar>
        <fui-modal-window-main>
            <fui-row>
                <fui-text-control [value]="url" [label]="'Sign Up URL'" (click)="selectText()" #urlControl></fui-text-control>
            </fui-row>
        </fui-modal-window-main>
        <fui-modal-window-footer>
            <fui-buttons>
                <fui-action-button class="content-cancel-button"
                                   [title]="'Copy'"
                                   (click)="copyUrl()">
                    <fui-icon [height]="12" [icon]="'clone'" [width]="12"></fui-icon>
                </fui-action-button>
                <fui-action-button class="content-cancel-button"
                                   [title]="'fhm.common.button.done'"
                                   (click)="close()">
                    <fui-icon [height]="12" [icon]="'close'" [width]="12"></fui-icon>
                </fui-action-button>
            </fui-buttons>
        </fui-modal-window-footer>
    </fui-modal-window>
</fui-modal>
